import AbstractPolicy from "@/policies/Proposal/Product/ProductPolicy/AbstractPolicy";
import Product from "@/models/Proposal/Product/Product";

export default class NoNotifyPolicy extends AbstractPolicy {

    static deleteAgentAccepted(user, product) {
        if (product.proposal_cancellation_id) {
            return false;
        }

        const productData = Product.query().with(['group.proposal', 'upsell', 'agentPreset.agentProduct.status']).find(product.id);
        const agentStatus = productData.agentPreset.agentProduct?.status;

        if (product.upsell) {
            return false;
        }

        if (!agentStatus || !agentStatus.locked) {
            return false;
        }

        if (productData.group.proposal.locked) {
            return false;
        }

        return user.HasPermission('customers.dossiers.proposals.write');
    }

}
